
        require('./index.scss');
        'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var $ = window.$;

var PicSwitch = function PicSwitch(config) {
    this.mod = $(config.mod);
    this.ele = $(config.mod).find(config.ele);
    this.dot = $(config.mod).find('.dots');
    this.banners = config.banners;
    this.page = 0;
    this.timer = null;
};

PicSwitch.prototype = {
    init: function init() {
        this.render();
        this.animate(0);
        this.event();
    },
    render: function render() {
        this.ele.empty();
        this.dot.empty();
        for (var i = 0; i < this.banners.length; i++) {
            var banner = this.banners[i];
            if (banner.input && banner.link && banner.img) {
                var a = $('<a class="banner" target="_blank"></a>');
                var img = $('<img>');
                var p = $('<p class="info"></p>');
                var dot = $('<div class="dot"></div>');
                a.attr('href', banner.link);
                img.attr('src', banner.img);
                p.text(banner.input);
                a.append(img);
                a.append(p);
                a.append($('<div class="mask"></div>'));
                if (banner.adFlag && banner.adFlag == 1) {
                    var span = $('<span class="banner-ad-mask">广告</span>');
                    a.appen(span);
                }
                this.ele.append(a);
                this.mod.find('.dots').append(dot);
            }
        }
        var length = this.mod.find('.dots .dot').length;
        if (length > 1) {
            this.mod.find('.dots .dot').eq(0).addClass('active');
            this.mod.find('.dots .dot').eq(length - 1).css('margin-right', '10px');
        } else {
            this.mod.find('.dots .dot').remove();
        }
    },

    event: function event() {
        var _this = this,
            tSwitch,
            li = _this.ele.find('a');
        function switchFun() {
            _this.page = _this.page >= _this.ele.find('a').length - 1 ? 0 : _this.page + 1;
            _this.animate(_this.page);
        }
        this.timer = setInterval(switchFun, 6000);

        this.mod.find('.dots .dot').hover(function (event) {
            if ($(this).hasClass('active')) {
                return;
            }
            event.preventDefault();
            clearInterval(_this.timer);
            var index = $(this).index();
            _this.page = index;
            _this.animate(_this.page);
        }, function () {
            clearInterval(_this.timer);
            _this.timer = setInterval(switchFun, 6000);
        });

        this.mod.find('.dots .dot').click(function (event) {
            event.preventDefault();
        });
    },
    animate: function animate(page) {
        if (this.ele.find('a').length <= 1) return;
        var li = this.ele.find('a'),
            _this = this;
        this.mod.find('.dots .dot').removeClass('active');
        $(this.mod.find('.dots .dot')[page]).addClass('active');
        li.hide();
        $(li[page]).css('opacity', 0.3).show().animate({ 'opacity': 1 }, 600);
        window.FCAdLog && window.FCAdLog.elPv(this.mod.find('.banner-list .banner').eq(page));
    }
};
exports['default'] = PicSwitch;;
    


// WEBPACK FOOTER //
// ./src/module/home-index/decoration/banner/index.js